import { tanStackQueryClient } from '@siloreal:app:config/third-party/tanstack-query';
import { QueryClientProvider } from '@tanstack/react-query';
import { PropsWithChildren } from 'react';

export function TanStackQueryProvider({ children }: PropsWithChildren) {
  return <QueryClientProvider client={tanStackQueryClient}>{children}</QueryClientProvider>;
}

// curl 'https://dev-api.siloreal.net/login' \
//   --compressed \
//   -X POST \
//   -H 'User-Agent: Mozilla/5.0 (Windows NT 10.0; Win64; x64; rv:147.0) Gecko/20100101 Firefox/147.0' \
//   -H 'Accept: application/json, text/plain, */*' \
//   -H 'Accept-Language: es-AR,es;q=0.9,en-US;q=0.8,en;q=0.7' \
//   -H 'Accept-Encoding: gzip, deflate, br, zstd' \
//   -H 'Content-Type: application/json' \
//   -H 'Origin: http://localhost:3000' \
//   -H 'Connection: keep-alive' \
//   -H 'Referer: http://localhost:3000/' \
//   -H 'Sec-Fetch-Dest: empty' \
//   -H 'Sec-Fetch-Mode: cors' \
//   -H 'Sec-Fetch-Site: cross-site' \
//   -H 'Priority: u=0' \
//   -H 'TE: trailers' \
//   --data-raw '{"email":"leoscalesi@hotmail.com","password":"iof2023"}'

// curl 'https://dev-api.siloreal.net/login' \
//   --compressed \
//   -X POST \
//   -H 'User-Agent: Mozilla/5.0 (Windows NT 10.0; Win64; x64; rv:147.0) Gecko/20100101 Firefox/147.0' \
//   -H 'Accept: */*' \
//   -H 'Accept-Language: es-AR,es;q=0.9,en-US;q=0.8,en;q=0.7' \
//   -H 'Accept-Encoding: gzip, deflate, br, zstd' \
//   -H 'Referer: http://localhost:3000/' \
//   -H 'content-type: application/json' \
//   -H 'Origin: http://localhost:3000' \
//   -H 'Connection: keep-alive' \
//   -H 'Sec-Fetch-Dest: empty' \
//   -H 'Sec-Fetch-Mode: cors' \
//   -H 'Sec-Fetch-Site: cross-site' \
//   -H 'Priority: u=0' \
//   -H 'TE: trailers' \
//   --data-raw '{"username":"leoscalesi@hotmail.com","password":"iof2023"}'
